module.exports = __webpack_public_path__ + "img/banner.c76b65c7.png";